import React from 'react';
import { motion } from 'framer-motion';
import { Check, BookOpen, ClipboardList, GraduationCap } from 'lucide-react';
export function MainPackStack() {
  const guides = [{
    title: 'Comer sin Miedo',
    icon: <BookOpen className="w-6 h-6 text-white" data-id="element-161" />,
    value: '$29.99',
    features: ['Listado completo de alimentos seguros organizados por categoría', 'Combinaciones inteligentes que mantienen tu glucosa estable', 'Recetas prácticas que podés hacer en menos de 30 minutos', 'Estrategias para comer rico sin sentir que estás "a dieta"']
  }, {
    title: 'Diabetes en Orden',
    icon: <ClipboardList className="w-6 h-6 text-white" data-id="element-162" />,
    value: '$29.99',
    features: ['Sistema de organización diaria paso a paso', 'Plantillas de seguimiento de glucosa y medicación', 'Rutinas semanales que se adaptan a tu estilo de vida', 'Checklist diario para nunca olvidar lo importante']
  }, {
    title: 'Lo Esencial sobre la Diabetes',
    icon: <GraduationCap className="w-6 h-6 text-white" data-id="element-163" />,
    value: '$24.99',
    features: ['Explicación simple de cómo funciona la diabetes tipo 2', 'Qué significan realmente tus números de glucosa', 'Mitos vs. realidades que cambian tu perspectiva', 'Base de conocimiento para tomar decisiones informadas']
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-164">
      <div className="max-w-5xl mx-auto" data-id="element-165">
        <div className="text-center mb-12" data-id="element-166">
          <span className="text-[#D97706] font-semibold tracking-wide uppercase text-sm" data-id="element-167">
            Lo que incluye tu pack
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B4332] mt-3" data-id="element-168">
            3 Guías Prácticas Que Reemplazan Meses de Búsqueda y Confusión
          </h2>
        </div>

        <div className="space-y-8" data-id="element-169">
          {guides.map((guide, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="flex flex-col md:flex-row bg-[#FEFBF4] rounded-2xl overflow-hidden border border-[#1B4332]/10 shadow-sm hover:shadow-md transition-shadow" data-id="element-170">
              {/* Header / Left Side */}
              <div className="bg-[#1B4332] p-6 md:w-1/3 flex flex-col justify-center items-center text-center md:items-start md:text-left" data-id="element-171">
                <div className="bg-[#D97706] p-3 rounded-full mb-4 inline-block" data-id="element-172">
                  {guide.icon}
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-173">
                  {guide.title}
                </h3>
                <div className="mt-auto pt-4 border-t border-white/20 w-full" data-id="element-174">
                  <p className="text-[#86EFAC] text-sm font-medium" data-id="element-175">
                    Valor: {guide.value}
                  </p>
                </div>
              </div>

              {/* Content / Right Side */}
              <div className="p-6 md:w-2/3 flex flex-col justify-center" data-id="element-176">
                <ul className="space-y-3" data-id="element-177">
                  {guide.features.map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-178">
                      <Check className="w-5 h-5 text-[#D97706] flex-shrink-0 mt-0.5" data-id="element-179" />
                      <span className="text-[#1C1917]/80" data-id="element-180">{feature}</span>
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-10 text-center" data-id="element-181">
          <p className="text-xl font-bold text-[#1B4332] bg-[#E6F4EA] inline-block px-6 py-3 rounded-full" data-id="element-182">
            Valor total del pack principal:{' '}
            <span className="line-through text-gray-500 text-lg" data-id="element-183">$84.97</span>
          </p>
        </div>
      </div>
    </section>;
}